import { defineMessages } from 'react-intl';

export default defineMessages({
    repayConfirmed: {
        id: '_.processing_payment.modal.early_repayment.confirmed',
        defaultMessage:
            '{amount} has been repaid by your debit card ending {paymentMethod}'
    },
    repayConfirmedSubtitle: {
        id: '_.processing_payment.modal.early_repayment.subtitle',
        defaultMessage: 'Your outstanding balance may take a moment to update'
    },
    drawDownConfirmed: {
        id: '_.processing_payment.modal.draw_down.confirmed',
        defaultMessage: `We've sent {amount} to your bank account`
    },
    interestOnlyExtensionConfirmed: {
        id: '_.processing_payment.modal.interest_only_extension.confirmed',
        defaultMessage: `We've extended your interest-only period`
    },
    repaymentReductionConfirmed: {
        id: '_.processing_payment.modal.repayment_reduction.confirmed',
        defaultMessage: `You have successfully reduced your monthly repayments`
    },
    returnToDashboard: {
        id: '_.navigation.return_to_dashboard',
        defaultMessage: 'Return to dashboard'
    }
});
